import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './HelpFaqSettings.scss';

const HelpFaqSettings: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="help-faq-settings">
      <div
        className="help-faq-settings__item"
        onClick={() =>
          window.open(
            'https://demind-inc.notion.site/Customer-Support-26f7c97113e68070a6e0e6a838da5f4a',
            '_blank'
          )
        }
      >
        <p>{t('settings.about.helpFaq')}</p>
      </div>
      <div
        className="help-faq-settings__item"
        onClick={() => window.open('https://feedback.lifestack.ai', '_blank')}
      >
        {t('settings.about.shareFeedback')}
      </div>
      <div
        className="help-faq-settings__item"
        onClick={() => window.open('mailto:contact@demind-inc.com', '_blank')}
      >
        <p>{t('settings.about.contactSupport')}</p>
      </div>
      <div
        className="help-faq-settings__item"
        onClick={() => window.open('https://www.reddit.com/r/Lifestack/', '_blank')}
      >
        <p>{t('settings.about.community')}</p>
      </div>
      <div
        className="help-faq-settings__item"
        onClick={() =>
          window.open('https://calendly.com/hayatowaki/lifestack-onboarding-w-hayato', '_blank')
        }
      >
        {t('settings.about.talkToFounders')}
      </div>
      <div
        className="help-faq-settings__item"
        onClick={() =>
          window.open(
            'https://demind-inc.notion.site/Privacy-Policy-Lifestack-867d4c361ca744e0a01be8645e951998?pvs=4',
            '_blank'
          )
        }
      >
        {t('settings.about.privacyPolicy')}
      </div>
      <div
        className="help-faq-settings__item"
        onClick={() => window.open('https://lifestack.ai', '_blank')}
      >
        {t('settings.about.aboutUs')}
      </div>
    </div>
  );
};

export default HelpFaqSettings;
